import { useNormalizedComposers } from './useNormalizedComposers';
import { useSortedRows } from './useSortedRows';
function useSortComposers(options) {
    const { composers, sortId, sortOrder } = options;
    const rows = useNormalizedComposers(composers);
    const sortedRows = useSortedRows({ rows, sortId, sortOrder });
    return sortedRows;
}
export { useSortComposers };
